module.exports = __webpack_public_path__ + "media/images/country_flags/gw-a7d4d118f41acc77cfffaa9aa4eb8db5.png";